<era-fanspeed-ui [fanspeed]="currentFanspeed()"></era-fanspeed-ui>